import { createFileRoute } from "@tanstack/react-router";

import { ChecklistManagerPage } from "@/components/pages/ChecklistManagerPage";
import type { ChecklistManagerTab } from "@/lib/checklist-manager";

type ChecklistManagerSearch = {
  tab?: ChecklistManagerTab;
};

const VALID_TABS: ChecklistManagerTab[] = [
  "history",
  "due-soon",
  "failed",
  "templates",
];

export const Route = createFileRoute("/_authenticated/checklist-manager/")({
  validateSearch: (
    search: Record<string, unknown>,
  ): ChecklistManagerSearch => ({
    tab: VALID_TABS.includes(search.tab as ChecklistManagerTab)
      ? (search.tab as ChecklistManagerTab)
      : undefined,
  }),
  component: ChecklistManagerPage,
});
